import PropTypes from "prop-types";

export const Button = ({
  children,
  type = "button",
  variant = "primary",
  className = "",
  onClick,
  disabled = false,
  loading = false,
  fullWidth = true
}) => {
  const baseStyles = `${fullWidth ? 'w-full' : 'px-8'} py-3 text-lg font-semibold rounded-xl shadow focus:outline-none focus:ring-2 focus:ring-cyan-300 transition flex items-center justify-center`;

  const variants = {
    primary: "bg-gradient-to-r from-[#30c1ff] to-[#19a3e4] text-white hover:from-[#40d1ff] hover:to-[#29b3f4]",
    secondary: "bg-transparent border border-jp-line text-jp-ink hover:bg-jp-line",
    danger: "bg-red-600 hover:bg-red-500 text-white",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseStyles} ${variants[variant] || variants.primary} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {loading ? "Loading..." : children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default Button;
